import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@printtat/shared';
import { ConnectionError } from '@/components/ConnectionError';

export const AdminGuard = ({ children }: { children: React.ReactNode }) => {
  const { user, loading, error, checkAuth } = useAuth();
  const location = useLocation();

  if (loading) return null;
  // Transient bootstrap failure (429/5xx/network): the refresh cookie may still
  // be valid, so offer a retry instead of bouncing a live session to sign-in.
  if (!user && error) return <ConnectionError message={error} onRetry={checkAuth} />;
  if (!user) return <Navigate to="/sign-in" replace />;
  if (user.role !== UserRole.ADMIN) return <Navigate to="/sign-in" replace />;
  // Phase 4 — admins must have MFA enabled. The backend AdminMfaGuard also
  // enforces this on /manage/* so this is purely a UX redirect; the API
  // would 403 otherwise.
  if (!user.totpEnabled && location.pathname !== '/mfa-setup') {
    return <Navigate to="/mfa-setup" replace />;
  }

  return <>{children}</>;
};
